<template>
  <div>
    <div class="container" style="background-color: white; text-align: left;">
      <h5 class="detail-h5">Service contract</h5>

      <div>
        <div class="row">
          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('contract') }}</dt>
              <dd class="col-sm-7">{{serviceContract.contractId}}</dd>

              <dt class="col-sm-5">{{ $t('contract_type') }}</dt>
              <dd class="col-sm-7">{{serviceContract.contractType}}</dd>

              <dt class="col-sm-5">{{ $t('start_date') }}</dt>
              <dd class="col-sm-7">{{serviceContract.startDate | moment("DD/MM/YYYY")}}</dd>

              <dt class="col-sm-5">{{ $t('end_date') }}</dt>
              <dd class="col-sm-7">{{serviceContract.endDate | moment("DD/MM/YYYY")}}</dd>
            </dl>
          </div>

          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('region_code') }}</dt>
              <dd class="col-sm-7">{{serviceContract.customer.customerName}}</dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <h5 class="detail-h5">{{ $t('service_objects') }}</h5>

        <div>
          <b-table
            responsive
            show-empty
            :empty-text="$t('no_service_objects_were_found')"
            ref="table"
            :busy.sync="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :per-page="perPage"
            :items="serviceContractsProvider"
            :fields="fields"
            @sort-changed="sortingChanged"
          >
            <template v-slot:table-busy>
              <div style="height: 32px;">
                <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                  <b-spinner></b-spinner>
                </div>
              </div>
            </template>
            <template v-slot:cell(serviceObjectId)="data">
              <a
                v-on:click="objectClick(data.item.serviceObjectId)"
                class="row-link"
              >{{data.item.serviceObjectId}}</a>
            </template>

            <template
              v-slot:cell(installationDate)="data"
            >{{data.item.installationDate | moment("DD/MM/YYYY")}}</template>

            <template
              v-slot:cell(warrantyEndDate)="data"
            >{{data.item.warrantyEndDate | moment("DD/MM/YYYY")}}</template>
          </b-table>

          <div class="row" style="text-align: left; margin-left: 0; margin-right: 0;">
            <div class="col-sm-6 offset-sm-3">
              <b-pagination
                v-if="totalRows > 0"
                align="center"
                ref="bottomPagination"
                label-prev-page="first"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
                style="margin-top: 10px !important"
              />
            </div>
            <div class="col-sm-3">
              <div class="form-group row" style="margin-top: 10px;">
                <label
                  for="inputPassword"
                  class="col-sm-7 col-form-label text-right"
                >{{ $t('lines_per_page') }}</label>
                <div class="col-sm-5">
                  <b-form-select
                    :options="pageOptions"
                    v-model="perPage"
                    :change="rowsPerPageChange()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { bus } from './../../main.js';
import { grid } from './../../mixins/grid.js';

const currentPage = 1;
const filter = '';

export default {
  name: 'ServiceContractDetail',
  mixins: [odata, grid],
  data: function() {
    return {
      serviceContract: {
        customer: {}
      },
      filter: filter,
      orderString: '',
      isBusy: false,
      sortBy: 'objectId',
      sortDesc: false,
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: currentPage,
      perPage: this.getPerPage(this, 'sc-so-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  methods: {
    sortingChanged(ctx) {
      this.orderString = '';

      this.orderString = this.generateOdataOrderByConditionString(
        ctx.sortBy,
        ctx.sortDesc,
        'serviceObjects'
      );
    },
    serviceContractsProvider(ctx) {
      var serviceContractId = this.$route.params.id;

      this.filter = "&$filter=contractId eq '" + serviceContractId + "'";

      var url = this.getServiceUr(
        'serviceobjects',
        ctx,
        this.filter,
        this.orderString
      );

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    objectClick: function(objectNr) {
      this.$router.push({
        name: 'service-object',
        params: {
          id: objectNr
        }
      });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'sc-so-perPage', this.perPage);
    }
  },
  created() {
    var serviceContractId = this.$route.params.id;

    getServiceContract(this, serviceContractId);

    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function getServiceContract(context, serviceContractId) {
  let promise = context.$axios.get(
    'servicecontracts?serviceContractId=' + serviceContractId
  );

  return promise
    .then(data => {
      const item = data.data;

      context.serviceContract = item;
    })
    .catch(error => {
      console.log(error);
    });
}

function getTableFields(context) {
  return [
    {
      key: 'serviceObjectId',
      label: context.$t('object'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'customerInventoryId',
      label: context.$t('customerInventoryId'),
      sortable: true,
      thClass: 'th-300 tr-left custom-th',
      tdClass: 'tr-300 tr-left custom-tr'
    },
    {
      key: 'description',
      label: context.$t('description'),
      sortable: true,
      thClass: 'th-300 tr-left custom-th',
      tdClass: 'tr-300 tr-left custom-tr'
    },
    {
      key: 'itemId',
      label: context.$t('article_id'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'serialNo',
      label: context.$t('serialNo'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'coverageType',
      label: context.$t('coverage_type'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'installationDate',
      label: context.$t('installation_date'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'warrantyEndDate',
      label: context.$t('warrantyEndDate'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    }
  ];
}

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 525;

  var maxRows = tableHeight / 40;

  if (maxRows < 3) {
    return 3;
  }

  return Math.floor(maxRows);
}
</script>

<style scoped>
</style>
